import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Malaysian NRIC validator following Single Responsibility Principle
 */
export class MyValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Malaysian NRIC',
      pattern: /^\d{6}-?\d{2}-?\d{4}$/,
      length: 12
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Malaysian NRIC format must be YYMMDD-SS-NNNN'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Basic validation - Malaysian NRIC doesn't have a mathematical checksum
    // but we validate the structure
    const birthDate = cleanId.substring(0, 6);
    const stateCode = cleanId.substring(6, 8);
    
    // Validate birth date format
    const year = parseInt(birthDate.substring(0, 2));
    const month = parseInt(birthDate.substring(2, 4));
    const day = parseInt(birthDate.substring(4, 6));
    
    if (month < 1 || month > 12) {
      return ValidationResult.invalid('Invalid birth month');
    }
    
    if (day < 1 || day > 31) {
      return ValidationResult.invalid('Invalid birth day');
    }

    return ValidationResult.valid('Valid Malaysian NRIC');
  }
}